import Seo from '@/components/base/Seo';
import { Link } from 'react-router-dom';

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-background-50 pt-24 pb-16 px-6">
      <Seo
        title="Cookies Policy | Healing & Breakthrough"
        description="Cookies Policy for Healing & Breakthrough. Learn about the cookies we use, how we use them, and how you can manage your cookie preferences."
        canonicalPath="/cookies-policy"
      />
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mb-8"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          Back to Home
        </Link>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-8">
          Cookies Policy
        </h1>
        <div className="space-y-6 text-sm text-foreground-600 leading-relaxed">
          <p>
            This Cookies Policy explains what cookies are and how we use them on the Healing & Breakthrough Coaching website.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            What Are Cookies
          </h2>
          <p>
            Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the website owners.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            How We Use Cookies
          </h2>
          <p>
            We use cookies for a variety of purposes, including to understand how visitors interact with our website, to improve user experience, and to analyse traffic patterns.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Types of Cookies We Use
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>Essential cookies:</strong> These are necessary for the website to function properly.
            </li>
            <li>
              <strong>Analytics cookies:</strong> These help us understand how visitors interact with our website by collecting and reporting information anonymously.
            </li>
            <li>
              <strong>Preference cookies:</strong> These enable the website to remember information that changes the way the website behaves or looks.
            </li>
          </ul>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Managing Cookies
          </h2>
          <p>
            You can control and manage cookies in various ways. Most browsers allow you to refuse or accept cookies, delete existing cookies, or set preferences for certain websites. Please be aware that disabling cookies may affect the functionality of this website.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Third-Party Cookies
          </h2>
          <p>
            We may use third-party services such as Google Analytics, which may set their own cookies to track user interactions and provide analytics data.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Changes to This Policy
          </h2>
          <p>
            We may update this cookies policy from time to time. Any changes will be posted on this page with an updated revision date.
          </p>

          <p className="pt-4">
            If you have any questions about our use of cookies, please contact{" "}
            <a href="mailto:federica.tedeschi3@gmail.com" className="text-primary-600 hover:underline">
              federica.tedeschi3@gmail.com
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}